import { render, staticRenderFns } from "./myMdTc.vue?vue&type=template&id=188aa262&scoped=true&"
import script from "./myMdTc.vue?vue&type=script&lang=js&"
export * from "./myMdTc.vue?vue&type=script&lang=js&"
import style0 from "./myMdTc.vue?vue&type=style&index=0&id=188aa262&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188aa262",
  null
  
)

export default component.exports